module.exports = __webpack_public_path__ + "static/media/WTBFB.8527a323.jpg";